import type { ReactNode } from "react";

import { localizedHref } from "../i18n/lang";

const VARIANT = {
  primary:
    "bg-magenta text-white shadow-soft hover:bg-magenta-deep hover:-translate-y-0.5 hover:shadow-lift",
  secondary:
    "border border-hairline-strong text-ink hover:border-ink hover:bg-ink hover:text-ivory",
  ghost: "text-teal-deep hover:text-ink underline-offset-4 hover:underline",
} as const;
const SIZE = {
  md: "min-h-11 px-5 text-sm",
  lg: "min-h-12 px-7 text-base",
} as const;

interface ButtonProps {
  href?: string;
  external?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: keyof typeof VARIANT;
  size?: keyof typeof SIZE;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export function Button({
  href,
  external,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  disabled,
  className = "",
  children,
}: ButtonProps) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wide transition duration-300 outline-teal-deep focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-soft ${VARIANT[variant]} ${SIZE[size]} ${className}`;
  if (href) {
    return (
      <a
        href={localizedHref(href, external)}
        className={cls}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
      >
        {children}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={cls}>
      {children}
    </button>
  );
}
